import React from "react";

/**
 * R6 B4 — Reminder Responsiveness (line chart + table).
 */
export default function ReminderResponsiveness({ weekly = [], perRep = [], onDrill }) {
  const w = 720, h = 180, pad = 24;
  const maxPct = 100;
  const stepX = weekly.length > 1 ? (w - pad * 2) / (weekly.length - 1) : 0;
  const points = weekly.map((p, i) => {
    const x = pad + i * stepX;
    const y = h - pad - (p.pct / maxPct) * (h - pad * 2);
    return { x, y, p };
  });
  const pathD = points.map((p, i) => `${i === 0 ? "M" : "L"}${p.x},${p.y}`).join(" ");

  return (
    <div className="r6-analytics-block">
      <h3 className="r6-analytics-title">Reminder Responsiveness (last 12 weeks)</h3>
      {weekly.length > 0 ? (
        <svg viewBox={`0 0 ${w} ${h}`} className="r6-line-chart" role="img" aria-label="Reminder responsiveness">
          <line x1={pad} y1={h - pad} x2={w - pad} y2={h - pad} stroke="#dde5ee" />
          <line x1={pad} y1={pad} x2={pad} y2={h - pad} stroke="#dde5ee" />
          <path d={pathD} fill="none" stroke="#48a0dc" strokeWidth="2" />
          {points.map((p, i) => (
            <circle key={i} cx={p.x} cy={p.y} r="3" fill="#48a0dc" />
          ))}
        </svg>
      ) : (
        <div className="r6-analytics-empty">No completed reminders in range</div>
      )}
      <div className="r6-analytics-table-wrap">
        <table className="r6-analytics-table">
          <thead>
            <tr><th>Rep</th><th>On time</th><th>Total</th><th>%</th></tr>
          </thead>
          <tbody>
            {perRep.length === 0 && (
              <tr><td colSpan={4} className="r6-analytics-empty">No data</td></tr>
            )}
            {perRep.map((r) => (
              <tr
                key={r.rep_id}
                className="r6-analytics-clickable"
                onClick={() => onDrill?.({ salesRep: r.rep_id, nextContact: "recent" })}
              >
                <td>{r.rep_name}</td>
                <td>{r.on_time}</td>
                <td>{r.total}</td>
                <td>{r.pct}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}